/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Typography } from '@mui/material';

const LoginHeader = () => {
  return (
    <Typography
      variant='body1'
      sx={{
        fontSize: '16px',
        lineHeight: '24px',
        textAlign: 'center',
        color: 'secondary.contrastText',
        padding: '0 30px',
      }}
    >
      Sorenson for Zoom brings live American Sign Language (ASL) interpreters to
      any meeting.
    </Typography>
  );
};

export default LoginHeader;
